import { pathIndicesFromKey, pathKeyFromIndices } from './temarioTree';

/**
 * @param {string} pestana
 * @param {number[]} [pathIndices]
 * @returns {string}
 */
export function buildCampusNavHref(pestana, pathIndices = []) {
  const label = typeof pestana === 'string' ? pestana.trim() : '';
  const params = new URLSearchParams();
  if (label.length > 0) {
    params.set('pestana', label);
  }
  if (Array.isArray(pathIndices) && pathIndices.length > 0) {
    params.set('nav', pathKeyFromIndices(pathIndices));
  }
  const query = params.toString();
  return query.length > 0 ? `/usuario/campus?${query}` : '/usuario/campus';
}

/**
 * @param {string} pestana
 * @param {string} [blockName]
 * @param {string} [topicName]
 * @returns {string}
 */
export function buildTestNavHref(pestana, blockName = '', topicName = '') {
  const params = new URLSearchParams();
  const label = typeof pestana === 'string' ? pestana.trim() : '';
  if (label.length > 0) {
    params.set('pestana', label);
  }
  const bloque = typeof blockName === 'string' ? blockName.trim() : '';
  if (bloque.length > 0) {
    params.set('bloque', bloque);
  }
  const tema = typeof topicName === 'string' ? topicName.trim() : '';
  if (tema.length > 0) {
    params.set('tema', tema);
  }
  return `/usuario/test-temas?${params.toString()}`;
}

/**
 * @param {string} pestana
 * @param {string} [blockName]
 * @param {string} [topicName]
 * @returns {string}
 */
export function buildCampusTestNavHref(pestana, blockName = '', topicName = '') {
  const params = new URLSearchParams();
  const label = typeof pestana === 'string' ? pestana.trim() : '';
  if (label.length > 0) {
    params.set('pestana', label);
  }
  const bloque = typeof blockName === 'string' ? blockName.trim() : '';
  if (bloque.length > 0) {
    params.set('bloque', bloque);
  }
  const tema = typeof topicName === 'string' ? topicName.trim() : '';
  if (tema.length > 0) {
    params.set('tema', tema);
  }
  const query = params.toString();
  return query.length > 0 ? `/usuario/campus?${query}` : '/usuario/campus';
}

/**
 * @param {string} search
 * @returns {number[]}
 */
export function parseNavPathFromSearch(search) {
  const params = new URLSearchParams(typeof search === 'string' ? search : '');
  return pathIndicesFromKey(params.get('nav') || '');
}

/**
 * @param {string} search
 * @returns {{ pestana: string, navPath: number[], bloque: string, tema: string, archivo: string }}
 */
export function parseStudentNavQuery(search) {
  const params = new URLSearchParams(typeof search === 'string' ? search : '');
  return {
    pestana: (params.get('pestana') || '').trim(),
    navPath: pathIndicesFromKey(params.get('nav') || ''),
    bloque: (params.get('bloque') || '').trim(),
    tema: (params.get('tema') || '').trim(),
    archivo: (params.get('archivo') || '').trim(),
  };
}

/**
 * @param {number[]} navPath
 * @param {number[]} candidatePrefix
 * @returns {boolean}
 */
export function navPathStartsWith(navPath, candidatePrefix) {
  if (!Array.isArray(navPath) || !Array.isArray(candidatePrefix)) {
    return false;
  }
  if (candidatePrefix.length > navPath.length) {
    return false;
  }
  return candidatePrefix.every((value, index) => navPath[index] === value);
}

export function buildTopicNodeDomId(pathIndices) {
  const key = pathKeyFromIndices(pathIndices);
  return key.length > 0 ? `topic-node-${key}` : '';
}
